import type { BridgeMessageHandler } from '../message-router.js';
import { parsePreviewEnvironmentDefs } from '../../preview-environments/manager/parse-config.js';

const VALID_PORT = (p: unknown): p is number =>
  typeof p === 'number' && Number.isInteger(p) && p > 0 && p < 65536;

export const handlePreviewEnvironmentsConfig: BridgeMessageHandler<'preview_environments_config'> = (msg, deps) => {
  const previewEnvironments = msg.previewEnvironments;
  const proxyPorts = Array.isArray(msg.proxyPorts) ? msg.proxyPorts.filter(VALID_PORT) : undefined;
  setImmediate(() => {
    deps.previewEnvironmentManager?.applyConfig(previewEnvironments ?? []);
    const environmentIds = parsePreviewEnvironmentDefs(previewEnvironments ?? []).map((d) => d.environmentId);
    void deps.previewWorktreeManager?.syncConfiguredEnvironments(environmentIds);
    if (proxyPorts !== undefined) {
      deps.updateFirehoseProxyPorts?.(proxyPorts);
    }
  });
};
